export const profileHeaderStyle = {
	wrapper: {
		width: '100%',
		margin: '0 auto',
		marginBottom: '24px',

		'@media (max-width: 639.98px)': {
			marginBottom: '0',
			display: 'none',
		},
	},

	tabs: {
		background: 'var(--default-white)',
		padding: '24px 0',
		maxHeight: '36px',
		borderRadius: '8px 8px 0 0',
	},

	tab: {
		flexShrink: '1',
		width: '100%',
		zIndex: 99,
	},
};
